/**
 * useDND Hook
 * React Query hook for Do Not Disturb state management
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as userSettingsService from '../services/user-settings.service';

export const useDND = () => {
  const queryClient = useQueryClient();

  // Get current DND status with automatic refresh every minute
  const { data: status, isLoading } = useQuery({
    queryKey: ['dnd-status'],
    queryFn: userSettingsService.getDNDStatus,
    refetchInterval: 60000, // Refetch every minute to update time remaining
  });

  // Enable DND mutation
  const enableMutation = useMutation({
    mutationFn: (duration?: number) => userSettingsService.enableDND(duration),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dnd-status'] });
      queryClient.invalidateQueries({ queryKey: ['user-settings'] });
    },
  });

  // Disable DND mutation
  const disableMutation = useMutation({
    mutationFn: userSettingsService.disableDND,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dnd-status'] });
      queryClient.invalidateQueries({ queryKey: ['user-settings'] });
    },
  });

  return {
    status,
    isLoading,
    enable: enableMutation.mutate,
    disable: disableMutation.mutate,
    isEnabling: enableMutation.isPending,
    isDisabling: disableMutation.isPending,
  };
};
